import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Modal, Text } from 'components-guide';
import { SubscribeNewsletter } from 'components';

import './SubscribeModal.scss';

export interface SubscribeProps {
    /**
     * Class name styles
     */
    className?: string;
    /**
     * Style
     */
    style?: any;
}

const SubscribeModal: React.FC<SubscribeProps> = ({ className, style }) => {
    const { t } = useTranslation();
    const classNames = classnames(['subscribe-modal', className]);
    const [modalOpened, setModalOpened] = useState(false);

    useEffect(() => {
        document.addEventListener(
            'openSubscriptionModal',
            function (e) {
                setModalOpened(!modalOpened);
            },
            false
        );
    }, []);

    const handleClose = () => setModalOpened(false);

    return (
        <div className={classNames} style={style}>
            <Modal opened={modalOpened} centered close onClose={handleClose}>
                <Text typo="h4" weight="bold" align="center">
                    {t('subscribe.title')}
                </Text>
                <Text>{t('subscribe.subtitle')}</Text>
                <SubscribeNewsletter onAfterSubmit={handleClose} />
            </Modal>
        </div>
    );
};

export default SubscribeModal;
